export const copyRichTextToClipboard = (html: string, text?: string) => {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  const copyText = text || tmp.textContent || tmp.innerText || "";

  var htmlType = "text/html";
  var textType = "text/plain";

  var htmlBlob = new Blob([html], { type: htmlType });
  var textBlob = new Blob([copyText], { type: textType });

  var data = [
    new ClipboardItem({
      [htmlType]: htmlBlob,
      [textType]: textBlob,
    }),
  ];
  navigator.clipboard.write(data);
};

export const getFullCaseName = ({
  citationText,
  court,
  dateFiled,
}: {
  citationText?: string;
  court?: string;
  dateFiled?: string;
}) => {
  let fullCaseName = "";
  try {
    const caseNameItems = [];
    if (citationText) {
      caseNameItems.push(citationText);
    }

    const courtName = court;
    if (courtName) {
      caseNameItems.push(courtName);
    }

    const year = dateFiled && new Date(dateFiled).getFullYear();
    if (year) {
      caseNameItems.push(year);
    }

    fullCaseName = caseNameItems.join("  |  ");

    return fullCaseName;
  } catch (error) {
    console.error("NotebookItemSubtitle error", error);
    return fullCaseName;
  }
};
